import type { IAuthRepository } from '../repositories/IAuthRepository.js';

interface Dependencies {
  authRepository: IAuthRepository;
}

export function createLogoutUseCase({ authRepository }: Dependencies) {
  return async function logout(): Promise<void> {
    return authRepository.logout();
  };
}
